import React from 'react';
import classes from './Button.module.css'

const CustomButton = ({children, className=classes.customButton, ...props}) => {

    return (
        <button {...props} className={className}>
            {children}
        </button>
    );
};

export default CustomButton;